import React from "react";
import JDPOWERImg from "assets/img/jd_logo.png";

// Define the JDPOWER component
const JDPOWER = () => {
	// Function to open the OFAC search URL in a new tab securely
	const openInNewTab = () => {
		const newWindow = window.open(
			"https://extapps.jdpowervalues.com/valuesonline",
			"_blank",
			"noopener,noreferrer"
		);
		if (newWindow) newWindow.opener = null;
	};

	return (
		<div onClick={openInNewTab}>
			<img src={JDPOWERImg} alt="J.D. POWER" style={{ cursor: "pointer" }} />
		</div>
	);
};

export default JDPOWER;
